import { render, staticRenderFns } from "./DatasetTree.vue?vue&type=template&id=5b248f08&scoped=true&"
import script from "./DatasetTree.vue?vue&type=script&lang=js&"
export * from "./DatasetTree.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTree.vue?vue&type=style&index=0&id=5b248f08&prod&scoped=true&lang=css&"
import style1 from "./DatasetTree.vue?vue&type=style&index=1&id=5b248f08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b248f08",
  null
  
)

export default component.exports